var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, action } from 'mobx';
import { getRoute } from 'utils/routes';
import { PATHNAMES } from 'utils/routes/consts';
import PanelStore from './PanelStore';
let VideoModalStore = (_class = class VideoModalStore {
  constructor() {
    _initializerDefineProperty(this, "currentVideo", _descriptor, this);
    _initializerDefineProperty(this, "videos", _descriptor2, this);
    _initializerDefineProperty(this, "index", _descriptor3, this);
    _initializerDefineProperty(this, "nextVideo", _descriptor4, this);
    _initializerDefineProperty(this, "previousVideo", _descriptor5, this);
    _initializerDefineProperty(this, "backgroundPage", _descriptor6, this);
    _initializerDefineProperty(this, "routingStore", _descriptor7, this);
    _initializerDefineProperty(this, "publicVideo", _descriptor8, this);
  }
  clearVideo() {
    this.currentVideo = null;
    this.videos = null;
    this.index = null;
    this.nextVideo = null;
    this.previousVideo = null;
  }
  setPublicVideo(video) {
    this.publicVideo = video;
  }
  setCurrentVideo(currentVideo, state) {
    const workspaceId = PanelStore.selectedPanel?.panelId;
    const videoRoute = getRoute(PATHNAMES.WORKSPACE_VIDEO_MODAL, {
      panelId: workspaceId,
      provider: currentVideo.provider,
      postId: currentVideo.postId
    });
    if (this.backgroundPage?.pathname?.includes('post')) {
      this.routingStore.push({
        pathname: videoRoute
      });
    } else {
      const backgroundPage = {
        ...this.backgroundPage,
        state: state ? state : null
      };
      this.routingStore.push({
        pathname: videoRoute,
        state: {
          backgroundPage
        }
      });
    }
    this.currentVideo = currentVideo;
  }
  setVideo({
    currentVideo,
    videos = null,
    index = null,
    changeBackground = true
  }, state) {
    if (changeBackground) {
      this.backgroundPage = {
        ...this.routingStore.location
      };
    }
    this.setCurrentVideo(currentVideo, state);
    this.videos = videos;
    this.index = index;
    this.nextVideo = null;
    this.previousVideo = null;
    if (videos && index >= 0) {
      this.nextVideo = videos[index + 1] || null;
      this.previousVideo = videos[index - 1] || null;
    }
  }
  loadNextVideo() {
    this.index = this.index + 1;
    this.setCurrentVideo(this.videos[this.index]);
    this.nextVideo = this.videos[this.index + 1] || null;
    this.previousVideo = this.videos[this.index - 1] || null;
  }
  loadPreviousVideo() {
    this.index = this.index - 1;
    this.setCurrentVideo(this.videos[this.index]);
    this.nextVideo = this.videos[this.index + 1] || null;
    this.previousVideo = this.videos[this.index - 1] || null;
  }
  setRoutingStore(routingStore) {
    this.routingStore = routingStore;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentVideo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "videos", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "index", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "nextVideo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "previousVideo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "backgroundPage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "routingStore", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "publicVideo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "clearVideo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPublicVideo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPublicVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentVideo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setVideo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadNextVideo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadNextVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadPreviousVideo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadPreviousVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRoutingStore", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRoutingStore"), _class.prototype), _class);
export default new VideoModalStore();